// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/font-woff;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 fill%3D%22none%22 viewBox%3D%220 0 48 48%22%3E    %3Cpath stroke%3D%22%23000%22 stroke-width%3D%223%22 d%3D%22M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z%22 clip-rule%3D%22evenodd%22 opacity%3D%22.2%22%2F%3E    %3Cpath stroke%3D%22%23000%22 stroke-width%3D%223%22 d%3D%22M24 4.5c10.77 0 19.5 8.73 19.5 19.5%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2218px%22 height%3D%2218px%22 viewBox%3D%220 0 18 18%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Ctitle%3EIcons %2F Core %2F Collapse %2F Dark BG - 24%3C%2Ftitle%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%221.3-ICONS-%2F-On-Dark%22 transform%3D%22translate%28-1739.000000%2C -4808.000000%29%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%221.5%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate%281736.000000%2C 4805.000000%29%22%3E                %3Cpolyline id%3D%22Stroke-2%22 points%3D%229.75 21 9.75 14.25 3 14.25%22%3E%3C%2Fpolyline%3E                %3Cpolyline id%3D%22Stroke-3%22 points%3D%2214.25 3 14.25 9.75 21 9.75%22%3E%3C%2Fpolyline%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2218px%22 height%3D%2218px%22 viewBox%3D%220 0 18 18%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Ctitle%3EIcons %2F Core %2F Expand %2F Dark BG - 24%3C%2Ftitle%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%221.3-ICONS-%2F-On-Dark%22 transform%3D%22translate%28-614.000000%2C -4883.000000%29%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%221.5%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate%28611.000000%2C 4880.000000%29%22%3E                %3Cpolyline id%3D%22Stroke-2%22 points%3D%223.75 13.5 3.75 20.25 10.5 20.25%22%3E%3C%2Fpolyline%3E                %3Cpolyline id%3D%22Stroke-3%22 points%3D%2220.25 10.5 20.25 3.75 13.5 3.75%22%3E%3C%2Fpolyline%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2222px%22 height%3D%2216px%22 viewBox%3D%220 0 22 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Ctitle%3EIcons %2F Media Controls %2F Closed Caption %2F Dark BG - 24 Filled%3C%2Ftitle%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%221.3-ICONS-%2F-On-Dark%22 transform%3D%22translate%28-387.000000%2C -6524.000000%29%22 fill%3D%22%23FFFFFF%22%3E            %3Cg id%3D%22Fill-2%22 transform%3D%22translate%28386.000000%2C 6520.000000%29%22%3E                %3Cpath d%3D%22M19.4932%2C12.9155 C19.4632%2C13.3835 19.3612%2C13.8165 19.1902%2C14.2025 C19.0182%2C14.5895 18.7832%2C14.9305 18.4882%2C15.2135 C18.1952%2C15.4955 17.8462%2C15.7165 17.4492%2C15.8715 C17.0532%2C16.0245 16.6122%2C16.1035 16.1402%2C16.1035 C15.5592%2C16.1035 15.0282%2C15.9935 14.5622%2C15.7775 C14.0982%2C15.5615 13.6992%2C15.2635 13.3782%2C14.8905 C13.0562%2C14.5175 12.8062%2C14.0785 12.6372%2C13.5845 C12.4672%2C13.0925 12.3812%2C12.5595 12.3812%2C11.9995 C12.3812%2C11.4475 12.4672%2C10.9175 12.6372%2C10.4265 C12.8062%2C9.9325 13.0562%2C9.4935 13.3772%2C9.1205 C13.6992%2C8.7475 14.0972%2C8.4465 14.5612%2C8.2285 C15.0252%2C8.0085 15.5562%2C7.8965 16.1402%2C7.8965 C16.5752%2C7.8965 16.9922%2C7.9575 17.3782%2C8.0785 C17.7702%2C8.2005 18.1172%2C8.3795 18.4112%2C8.6085 C18.7082%2C8.8395 18.9532%2C9.1255 19.1382%2C9.4575 C19.3222%2C9.7885 19.4382%2C10.1715 19.4822%2C10.5985 L19.4942%2C10.7085 L17.9682%2C10.7085 L17.9482%2C10.6335 C17.8942%2C10.4245 17.8182%2C10.2265 17.7222%2C10.0455 C17.6282%2C9.8725 17.5062%2C9.7195 17.3582%2C9.5925 C17.2142%2C9.4665 17.0392%2C9.3665 16.8392%2C9.2955 C16.6392%2C9.2245 16.4052%2C9.1885 16.1402%2C9.1885 C15.7532%2C9.1885 15.4142%2C9.2675 15.1342%2C9.4225 C14.8522%2C9.5795 14.6212%2C9.7905 14.4462%2C10.0495 C14.2662%2C10.3135 14.1342%2C10.6185 14.0492%2C10.9545 C13.9622%2C11.2945 13.9172%2C11.6455 13.9172%2C11.9995 C13.9172%2C12.3535 13.9622%2C12.7055 14.0492%2C13.0455 C14.1342%2C13.3815 14.2672%2C13.6855 14.4462%2C13.9505 C14.6212%2C14.2095 14.8522%2C14.4205 15.1342%2C14.5775 C15.4142%2C14.7315 15.7532%2C14.8105 16.1402%2C14.8105 C16.4242%2C14.8105 16.6772%2C14.7615 16.8912%2C14.6645 C17.1052%2C14.5675 17.2932%2C14.4315 17.4462%2C14.2605 C17.6002%2C14.0895 17.7232%2C13.8865 17.8112%2C13.6555 C17.9012%2C13.4235 17.9612%2C13.1685 17.9882%2C12.8985 L17.9972%2C12.8095 L19.5002%2C12.8095 L19.4932%2C12.9155 Z M11.6122%2C12.9155 C11.5822%2C13.3835 11.4802%2C13.8165 11.3092%2C14.2025 C11.1382%2C14.5895 10.9012%2C14.9305 10.6072%2C15.2135 C10.3142%2C15.4955 9.9652%2C15.7165 9.5682%2C15.8715 C9.1722%2C16.0245 8.7312%2C16.1035 8.2602%2C16.1035 C7.6792%2C16.1035 7.1472%2C15.9935 6.6812%2C15.7775 C6.2182%2C15.5615 5.8182%2C15.2635 5.4972%2C14.8905 C5.1752%2C14.5175 4.9262%2C14.0785 4.7562%2C13.5845 C4.5862%2C13.0925 4.5002%2C12.5595 4.5002%2C11.9995 C4.5002%2C11.4475 4.5862%2C10.9175 4.7562%2C10.4265 C4.9262%2C9.9325 5.1752%2C9.4935 5.4962%2C9.1205 C5.8182%2C8.7475 6.2172%2C8.4465 6.6802%2C8.2285 C7.1442%2C8.0085 7.6762%2C7.8965 8.2602%2C7.8965 C8.6952%2C7.8965 9.1122%2C7.9575 9.4982%2C8.0785 C9.8892%2C8.2015 10.2372%2C8.3795 10.5302%2C8.6085 C10.8272%2C8.8395 11.0722%2C9.1255 11.2572%2C9.4575 C11.4412%2C9.7885 11.5562%2C10.1715 11.6012%2C10.5985 L11.6132%2C10.7085 L10.0872%2C10.7085 L10.0672%2C10.6335 C10.0142%2C10.4245 9.9372%2C10.2265 9.8412%2C10.0455 C9.7472%2C9.8725 9.6252%2C9.7195 9.4782%2C9.5925 C9.3322%2C9.4665 9.1572%2C9.3665 8.9592%2C9.2955 C8.7592%2C9.2245 8.5242%2C9.1885 8.2602%2C9.1885 C7.8722%2C9.1885 7.5332%2C9.2675 7.2542%2C9.4225 C6.9722%2C9.5785 6.7402%2C9.7895 6.5652%2C10.0495 C6.3882%2C10.3115 6.2542%2C10.6165 6.1682%2C10.9545 C6.0812%2C11.2945 6.0362%2C11.6455 6.0362%2C11.9995 C6.0362%2C12.3535 6.0812%2C12.7055 6.1682%2C13.0455 C6.2542%2C13.3835 6.3882%2C13.6875 6.5652%2C13.9505 C6.7402%2C14.2105 6.9722%2C14.4205 7.2542%2C14.5775 C7.5332%2C14.7315 7.8722%2C14.8105 8.2602%2C14.8105 C8.5432%2C14.8105 8.7962%2C14.7615 9.0112%2C14.6645 C9.2242%2C14.5675 9.4112%2C14.4325 9.5652%2C14.2605 C9.7222%2C14.0875 9.8452%2C13.8845 9.9302%2C13.6555 C10.0202%2C13.4235 10.0802%2C13.1685 10.1072%2C12.8985 L10.1162%2C12.8095 L11.6192%2C12.8095 L11.6122%2C12.9155 Z M19.5002%2C4.4995 L4.5002%2C4.4995 C2.8462%2C4.4995 1.5002%2C5.8455 1.5002%2C7.4995 L1.5002%2C16.4995 C1.5002%2C18.1545 2.8462%2C19.4995 4.5002%2C19.4995 L19.5002%2C19.4995 C21.1542%2C19.4995 22.5002%2C18.1545 22.5002%2C16.4995 L22.5002%2C7.4995 C22.5002%2C5.8455 21.1542%2C4.4995 19.5002%2C4.4995 L19.5002%2C4.4995 Z%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2222px%22 height%3D%2216px%22 viewBox%3D%220 0 22 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Ctitle%3EIcons %2F Media Controls %2F Closed Caption %2F Dark BG - 24%3C%2Ftitle%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%221.3-ICONS-%2F-On-Dark%22 transform%3D%22translate%28-387.000000%2C -5675.000000%29%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate%28386.000000%2C 5671.000000%29%22%3E                %3Cg id%3D%22Group-6%22 transform%3D%22translate%282.000000%2C 5.000000%29%22%3E                    %3Cpath d%3D%22M17.5%2C7.8091 L17.493%2C7.9151 C17.463%2C8.3841 17.361%2C8.8171 17.19%2C9.2021 C17.019%2C9.5901 16.783%2C9.9301 16.488%2C10.2131 C16.195%2C10.4961 15.846%2C10.7171 15.449%2C10.8711 C15.053%2C11.0251 14.612%2C11.1031 14.141%2C11.1031 C13.56%2C11.1031 13.028%2C10.9941 12.563%2C10.7781 C12.099%2C10.5611 11.699%2C10.2631 11.378%2C9.8911 C11.056%2C9.5171 10.807%2C9.0781 10.637%2C8.5841 C10.467%2C8.0931 10.381%2C7.5591 10.381%2C7.0001 C10.381%2C6.4481 10.467%2C5.9181 10.637%2C5.4261 C10.807%2C4.9331 11.056%2C4.4931 11.377%2C4.1201 C11.699%2C3.7471 12.098%2C3.4471 12.562%2C3.2281 C13.025%2C3.0081 13.557%2C2.8971 14.141%2C2.8971 C14.575%2C2.8971 14.992%2C2.9581 15.378%2C3.0781 C15.771%2C3.2011 16.117%2C3.3791 16.411%2C3.6091 C16.708%2C3.8391 16.953%2C4.1251 17.138%2C4.4571 C17.322%2C4.7881 17.438%2C5.1721 17.482%2C5.5981 L17.494%2C5.7081 L15.968%2C5.7081 L15.948%2C5.6331 C15.895%2C5.4241 15.818%2C5.2261 15.722%2C5.0461 C15.628%2C4.8721 15.506%2C4.7191 15.358%2C4.5931 C15.214%2C4.4671 15.039%2C4.3671 14.839%2C4.2951 C14.64%2C4.2251 14.405%2C4.1891 14.141%2C4.1891 C13.753%2C4.1891 13.414%2C4.2671 13.134%2C4.4221 C12.853%2C4.5791 12.621%2C4.7901 12.446%2C5.0491 C12.267%2C5.3141 12.134%2C5.6191 12.049%2C5.9541 C11.962%2C6.2941 11.917%2C6.6461 11.917%2C7.0001 C11.917%2C7.3531 11.962%2C7.7051 12.049%2C8.0451 C12.134%2C8.3811 12.268%2C8.6851 12.446%2C8.9501 C12.621%2C9.2101 12.853%2C9.4211 13.134%2C9.5771 C13.414%2C9.7321 13.753%2C9.8101 14.141%2C9.8101 C14.424%2C9.8101 14.677%2C9.7621 14.892%2C9.6641 C15.105%2C9.5671 15.293%2C9.4311 15.446%2C9.2611 C15.601%2C9.0901 15.724%2C8.8861 15.812%2C8.6551 C15.901%2C8.4231 15.961%2C8.1691 15.988%2C7.8991 L15.997%2C7.8091 L17.5%2C7.8091 Z M8.116%2C7.8091 L9.619%2C7.8091 L9.612%2C7.9151 C9.582%2C8.3841 9.48%2C8.8171 9.31%2C9.2021 C9.138%2C9.5901 8.901%2C9.9301 8.607%2C10.2131 C8.314%2C10.4961 7.965%2C10.7171 7.568%2C10.8711 C7.172%2C11.0251 6.731%2C11.1031 6.26%2C11.1031 C5.679%2C11.1031 5.147%2C10.9941 4.682%2C10.7781 C4.218%2C10.5611 3.818%2C10.2631 3.497%2C9.8911 C3.175%2C9.5171 2.926%2C9.0781 2.756%2C8.5841 C2.586%2C8.0931 2.5%2C7.5591 2.5%2C7.0001 C2.5%2C6.4481 2.586%2C5.9181 2.756%2C5.4261 C2.926%2C4.9331 3.175%2C4.4931 3.496%2C4.1201 C3.818%2C3.7471 4.217%2C3.4471 4.681%2C3.2281 C5.145%2C3.0081 5.676%2C2.8971 6.26%2C2.8971 C6.695%2C2.8971 7.112%2C2.9581 7.498%2C3.0781 C7.89%2C3.2011 8.237%2C3.3791 8.53%2C3.6091 C8.827%2C3.8391 9.072%2C4.1251 9.257%2C4.4571 C9.441%2C4.7881 9.557%2C5.1721 9.602%2C5.5981 L9.613%2C5.7081 L8.087%2C5.7081 L8.067%2C5.6331 C8.014%2C5.4241 7.937%2C5.2261 7.841%2C5.0461 C7.747%2C4.8721 7.625%2C4.7201 7.479%2C4.5931 C7.332%2C4.4661 7.157%2C4.3661 6.959%2C4.2951 C6.759%2C4.2251 6.524%2C4.1891 6.26%2C4.1891 C5.872%2C4.1891 5.533%2C4.2671 5.254%2C4.4221 C4.973%2C4.5791 4.74%2C4.7891 4.565%2C5.0491 C4.388%2C5.3111 4.254%2C5.6161 4.168%2C5.9541 C4.081%2C6.2941 4.036%2C6.6461 4.036%2C7.0001 C4.036%2C7.3531 4.081%2C7.7051 4.168%2C8.0451 C4.254%2C8.3831 4.388%2C8.6881 4.565%2C8.9501 C4.74%2C9.2101 4.973%2C9.4211 5.254%2C9.5771 C5.533%2C9.7321 5.872%2C9.8101 6.26%2C9.8101 C6.543%2C9.8101 6.796%2C9.7621 7.011%2C9.6641 C7.225%2C9.5681 7.411%2C9.4321 7.565%2C9.2611 C7.722%2C9.0881 7.845%2C8.8841 7.931%2C8.6561 C8.021%2C8.4231 8.08%2C8.1691 8.107%2C7.8991 L8.116%2C7.8091 Z%22 id%3D%22Fill-2%22 fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E                    %3Cpath d%3D%22M17.5%2C13.75 L2.5%2C13.75 C1.258%2C13.75 0.25%2C12.743 0.25%2C11.5 L0.25%2C2.5 C0.25%2C1.257 1.258%2C0.25 2.5%2C0.25 L17.5%2C0.25 C18.742%2C0.25 19.75%2C1.257 19.75%2C2.5 L19.75%2C11.5 C19.75%2C12.743 18.742%2C13.75 17.5%2C13.75 Z%22 id%3D%22Stroke-4%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%221.5%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2212px%22 height%3D%2218px%22 viewBox%3D%220 0 12 18%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Ctitle%3EIcons %2F Media Controls %2F Pause %2F Dark BG - 24 Filled%3C%2Ftitle%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%221.3-ICONS-%2F-On-Dark%22 transform%3D%22translate%28-917.000000%2C -6523.000000%29%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate%28911.000000%2C 6520.000000%29%22%3E                %3Cg id%3D%22Group-10%22 transform%3D%22translate%286.000000%2C 3.000000%29%22%3E                    %3Cpath d%3D%22M9.75%2C17.25 L9.75%2C17.25 C8.922%2C17.25 8.25%2C16.578 8.25%2C15.75 L8.25%2C2.25 C8.25%2C1.422 8.922%2C0.75 9.75%2C0.75 C10.578%2C0.75 11.25%2C1.422 11.25%2C2.25 L11.25%2C15.75 C11.25%2C16.578 10.578%2C17.25 9.75%2C17.25%22 id%3D%22Fill-2%22 fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E                    %3Cpath d%3D%22M9.75%2C17.25 L9.75%2C17.25 C8.922%2C17.25 8.25%2C16.578 8.25%2C15.75 L8.25%2C2.25 C8.25%2C1.422 8.922%2C0.75 9.75%2C0.75 C10.578%2C0.75 11.25%2C1.422 11.25%2C2.25 L11.25%2C15.75 C11.25%2C16.578 10.578%2C17.25 9.75%2C17.25 Z%22 id%3D%22Stroke-4%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%221.5%22%3E%3C%2Fpath%3E                    %3Cpath d%3D%22M2.25%2C17.25 L2.25%2C17.25 C1.422%2C17.25 0.75%2C16.578 0.75%2C15.75 L0.75%2C2.25 C0.75%2C1.422 1.422%2C0.75 2.25%2C0.75 C3.078%2C0.75 3.75%2C1.422 3.75%2C2.25 L3.75%2C15.75 C3.75%2C16.578 3.078%2C17.25 2.25%2C17.25%22 id%3D%22Fill-6%22 fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E                    %3Cpath d%3D%22M2.25%2C17.25 L2.25%2C17.25 C1.422%2C17.25 0.75%2C16.578 0.75%2C15.75 L0.75%2C2.25 C0.75%2C1.422 1.422%2C0.75 2.25%2C0.75 C3.078%2C0.75 3.75%2C1.422 3.75%2C2.25 L3.75%2C15.75 C3.75%2C16.578 3.078%2C17.25 2.25%2C17.25 Z%22 id%3D%22Stroke-8%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%221.5%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2217px%22 height%3D%2218px%22 viewBox%3D%220 0 17 18%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Ctitle%3EIcons %2F Media Controls %2F Play %2F Dark BG - 24 Filled%3C%2Ftitle%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%221.3-ICONS-%2F-On-Dark%22 transform%3D%22translate%28-990.000000%2C -6523.000000%29%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate%28986.000000%2C 6520.000000%29%22%3E                %3Cg id%3D%22Group-6%22 transform%3D%22translate%285.000000%2C 3.000000%29%22%3E                    %3Cpath d%3D%22M14.3145%2C8.3506 L1.3675%2C0.8756 C0.8675%2C0.5866 0.2425%2C0.9476 0.2425%2C1.5256 L0.2425%2C16.4746 C0.2425%2C17.0526 0.8675%2C17.4136 1.3675%2C17.1236 L14.3145%2C9.6496 C14.8145%2C9.3616 14.8145%2C8.6386 14.3145%2C8.3506%22 id%3D%22Fill-2%22 fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E                    %3Cpath d%3D%22M14.3145%2C8.3506 L1.3675%2C0.8756 C0.8675%2C0.5866 0.2425%2C0.9476 0.2425%2C1.5256 L0.2425%2C16.4746 C0.2425%2C17.0526 0.8675%2C17.4136 1.3675%2C17.1236 L14.3145%2C9.6496 C14.8145%2C9.3616 14.8145%2C8.6386 14.3145%2C8.3506 Z%22 id%3D%22Stroke-4%22 stroke%3D%22%23FFFFFF%22 stroke-width%3D%221.5%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M12 3C7.038 3 3 7.038 3 12C3 16.963 7.038 21 12 21C12.04 21 12.079 20.996 12.119 20.995L10.78 22.334L11.841 23.395L14.648 20.586H14.649L15.022 20.212L14.025 19.215L11.841 17.03L10.78 18.091L12.177 19.487C12.117 19.488 12.06 19.5 12 19.5C7.864 19.5 4.5 16.136 4.5 12C4.5 7.864 7.864 4.5 12 4.5C16.136 4.5 19.5 7.864 19.5 12C19.5 14.855 17.895 17.343 15.541 18.608L16.633 19.701C19.244 18.124 21 15.268 21 12C21 7.038 16.962 3 12 3Z%22 fill%3D%22white%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2220px%22 height%3D%2220px%22 viewBox%3D%220 0 20 20%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Ctitle%3EIcons %2F Media Controls %2F Mute %2F Dark BG - 24 Filled%3C%2Ftitle%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%221.3-ICONS-%2F-On-Dark%22 transform%3D%22translate%28-839.000000%2C -6522.000000%29%22 fill%3D%22%23FFFFFF%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate%28836.000000%2C 6520.000000%29%22%3E                %3Cg id%3D%22Group-6%22 transform%3D%22translate%283.000000%2C 2.000000%29%22%3E                    %3Cpath d%3D%22M11.0742%2C0.6748 C10.5122%2C0.4418 9.8702%2C0.5708 9.4392%2C0.9998 L4.9392%2C5.4998 L0.0002%2C5.4998 L0.0002%2C14.4998 L4.9392%2C14.4998 L9.4392%2C18.9998 C9.7272%2C19.2878 10.1092%2C19.4408 10.4992%2C19.4408 C10.6922%2C19.4408 10.8872%2C19.4028 11.0742%2C19.3248 C11.6362%2C19.0918 12.0002%2C18.5478 12.0002%2C17.9398 L12.0002%2C2.0608 C12.0002%2C1.4518 11.6362%2C0.9078 11.0742%2C0.6748%22 id%3D%22Fill-2%22%3E%3C%2Fpath%3E                    %3Cpolygon id%3D%22Fill-4%22 points%3D%2219.8584 7.8789 18.7974 6.8179 16.6764 8.9399 14.5554 6.8179 13.4954 7.8789 15.6164 9.9999 13.4954 12.1209 14.5554 13.1819 16.6764 11.0609 18.7974 13.1819 19.8584 12.1209 17.7374 9.9999%22%3E%3C%2Fpolygon%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2220px%22 height%3D%2220px%22 viewBox%3D%220 0 20 20%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Ctitle%3EIcons %2F Media Controls %2F Volume Low %2F Dark BG - 24 Filled%3C%2Ftitle%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%221.3-ICONS-%2F-On-Dark%22 transform%3D%22translate%28-1364.000000%2C -6522.000000%29%22 fill%3D%22%23FFFFFF%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate%281361.000000%2C 6520.000000%29%22%3E                %3Cg id%3D%22Group-6%22 transform%3D%22translate%283.000000%2C 2.000000%29%22%3E                    %3Cpath d%3D%22M11.0742%2C0.6748 C10.5122%2C0.4418 9.8712%2C0.5708 9.4392%2C0.9998 L4.9392%2C5.4998 L0.0002%2C5.4998 L0.0002%2C14.4998 L4.9392%2C14.4998 L9.4392%2C18.9998 C9.7272%2C19.2878 10.1092%2C19.4408 10.4992%2C19.4408 C10.6922%2C19.4408 10.8872%2C19.4028 11.0742%2C19.3248 C11.6362%2C19.0918 12.0002%2C18.5478 12.0002%2C17.9398 L12.0002%2C2.0608 C12.0002%2C1.4518 11.6362%2C0.9078 11.0742%2C0.6748%22 id%3D%22Fill-2%22%3E%3C%2Fpath%3E                    %3Cpolygon id%3D%22Fill-4%22 points%3D%2213.5 13 15 13 15 7 13.5 7%22%3E%3C%2Fpolygon%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2220px%22 height%3D%2220px%22 viewBox%3D%220 0 20 20%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Ctitle%3EIcons %2F Media Controls %2F Volume High %2F Dark BG - 24 Filled%3C%2Ftitle%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%221.3-ICONS-%2F-On-Dark%22 transform%3D%22translate%28-1289.000000%2C -6522.000000%29%22 fill%3D%22%23FFFFFF%22%3E            %3Cg id%3D%22Group%22 transform%3D%22translate%281286.000000%2C 6520.000000%29%22%3E                %3Cg id%3D%22Group-7%22 transform%3D%22translate%283.000000%2C 2.000000%29%22%3E                    %3Cpath d%3D%22M11.0742%2C0.6748 C10.5112%2C0.4418 9.8702%2C0.5708 9.4392%2C0.9998 L4.9392%2C5.4998 L0.0002%2C5.4998 L0.0002%2C14.4998 L4.9392%2C14.4998 L9.4392%2C18.9998 C9.7272%2C19.2878 10.1092%2C19.4408 10.4992%2C19.4408 C10.6922%2C19.4408 10.8872%2C19.4028 11.0742%2C19.3248 C11.6362%2C19.0918 12.0002%2C18.5478 12.0002%2C17.9398 L12.0002%2C2.0608 C12.0002%2C1.4518 11.6362%2C0.9078 11.0742%2C0.6748%22 id%3D%22Fill-2%22%3E%3C%2Fpath%3E                    %3Cpolygon id%3D%22Fill-4%22 points%3D%2213.5 13 15 13 15 7 13.5 7%22%3E%3C%2Fpolygon%3E                    %3Cpolygon id%3D%22Fill-6%22 points%3D%2216.5 14.5 18 14.5 18 5.5 16.5 5.5%22%3E%3C%2Fpolygon%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! NikeOneVideoPlayer - Version 2.0.1 */
.vjs-modal-dialog .vjs-modal-dialog-content, .video-js .vjs-modal-dialog, .vjs-button > .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.vjs-button > .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  text-align: center;
}

@font-face {
  font-family: VideoJS;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
.vjs-icon-play, .video-js .vjs-play-control .vjs-icon-placeholder, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-play:before, .video-js .vjs-play-control .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  content: "\\f101";
}

.vjs-icon-play-circle {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-play-circle:before {
  content: "\\f102";
}

.vjs-icon-pause, .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-pause:before, .video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before {
  content: "\\f103";
}

.vjs-icon-volume-mute, .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-volume-mute:before, .video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before {
  content: "\\f104";
}

.vjs-icon-volume-low, .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-volume-low:before, .video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before {
  content: "\\f105";
}

.vjs-icon-volume-mid, .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-volume-mid:before, .video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before {
  content: "\\f106";
}

.vjs-icon-volume-high, .video-js .vjs-mute-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-volume-high:before, .video-js .vjs-mute-control .vjs-icon-placeholder:before {
  content: "\\f107";
}

.vjs-icon-fullscreen-enter, .video-js .vjs-fullscreen-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-fullscreen-enter:before, .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {
  content: "\\f108";
}

.vjs-icon-fullscreen-exit, .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-fullscreen-exit:before, .video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before {
  content: "\\f109";
}

.vjs-icon-square {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-square:before {
  content: "\\f10a";
}

.vjs-icon-spinner {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-spinner:before {
  content: "\\f10b";
}

.vjs-icon-subtitles, .video-js .vjs-subs-caps-button .vjs-icon-placeholder, .video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder, .video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder, .video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder, .video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder, .video-js .vjs-subtitles-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-subtitles:before, .video-js .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js .vjs-subtitles-button .vjs-icon-placeholder:before {
  content: "\\f10c";
}

.vjs-icon-captions, .video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder, .video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder, .video-js .vjs-captions-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-captions:before, .video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before, .video-js .vjs-captions-button .vjs-icon-placeholder:before {
  content: "\\f10d";
}

.vjs-icon-chapters, .video-js .vjs-chapters-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-chapters:before, .video-js .vjs-chapters-button .vjs-icon-placeholder:before {
  content: "\\f10e";
}

.vjs-icon-share {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-share:before {
  content: "\\f10f";
}

.vjs-icon-cog {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-cog:before {
  content: "\\f110";
}

.vjs-icon-circle, .vjs-seek-to-live-control .vjs-icon-placeholder, .video-js .vjs-volume-level, .video-js .vjs-play-progress {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-circle:before, .vjs-seek-to-live-control .vjs-icon-placeholder:before, .video-js .vjs-volume-level:before, .video-js .vjs-play-progress:before {
  content: "\\f111";
}

.vjs-icon-circle-outline {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-circle-outline:before {
  content: "\\f112";
}

.vjs-icon-circle-inner-circle {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-circle-inner-circle:before {
  content: "\\f113";
}

.vjs-icon-hd {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-hd:before {
  content: "\\f114";
}

.vjs-icon-cancel, .video-js .vjs-control.vjs-close-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-cancel:before, .video-js .vjs-control.vjs-close-button .vjs-icon-placeholder:before {
  content: "\\f115";
}

.vjs-icon-replay, .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-replay:before, .video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before {
  content: "\\f116";
}

.vjs-icon-facebook {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-facebook:before {
  content: "\\f117";
}

.vjs-icon-gplus {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-gplus:before {
  content: "\\f118";
}

.vjs-icon-linkedin {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-linkedin:before {
  content: "\\f119";
}

.vjs-icon-twitter {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-twitter:before {
  content: "\\f11a";
}

.vjs-icon-tumblr {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-tumblr:before {
  content: "\\f11b";
}

.vjs-icon-pinterest {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-pinterest:before {
  content: "\\f11c";
}

.vjs-icon-audio-description, .video-js .vjs-descriptions-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-audio-description:before, .video-js .vjs-descriptions-button .vjs-icon-placeholder:before {
  content: "\\f11d";
}

.vjs-icon-audio, .video-js .vjs-audio-button .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-audio:before, .video-js .vjs-audio-button .vjs-icon-placeholder:before {
  content: "\\f11e";
}

.vjs-icon-next-item {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-next-item:before {
  content: "\\f11f";
}

.vjs-icon-previous-item {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-previous-item:before {
  content: "\\f120";
}

.vjs-icon-picture-in-picture-enter, .video-js .vjs-picture-in-picture-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-picture-in-picture-enter:before, .video-js .vjs-picture-in-picture-control .vjs-icon-placeholder:before {
  content: "\\f121";
}

.vjs-icon-picture-in-picture-exit, .video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-picture-in-picture-exit:before, .video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder:before {
  content: "\\f122";
}

.video-js {
  display: block;
  vertical-align: top;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: normal;
  font-style: normal;
  font-family: Arial, Helvetica, sans-serif;
  word-break: initial;
}

.video-js:-moz-full-screen {
  position: absolute;
}

.video-js:-webkit-full-screen {
  width: 100% !important;
  height: 100% !important;
}

.video-js[tabindex="-1"] {
  outline: none;
}

.video-js *, .video-js *:before, .video-js *:after {
  box-sizing: inherit;
}

.video-js ul {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  list-style-position: outside;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3, .video-js.vjs-9-16, .video-js.vjs-1-1 {
  width: 100%;
  max-width: 100%;
}

.video-js.vjs-fluid:not(.vjs-audio-only-mode), .video-js.vjs-16-9:not(.vjs-audio-only-mode), .video-js.vjs-4-3:not(.vjs-audio-only-mode), .video-js.vjs-9-16:not(.vjs-audio-only-mode), .video-js.vjs-1-1:not(.vjs-audio-only-mode) {
  height: 0;
}

.video-js.vjs-16-9:not(.vjs-audio-only-mode) {
  padding-top: 56.25%;
}

.video-js.vjs-4-3:not(.vjs-audio-only-mode) {
  padding-top: 75%;
}

.video-js.vjs-9-16:not(.vjs-audio-only-mode) {
  padding-top: 177.7777777778%;
}

.video-js.vjs-1-1:not(.vjs-audio-only-mode) {
  padding-top: 100%;
}

.video-js.vjs-fill:not(.vjs-audio-only-mode) {
  width: 100%;
  height: 100%;
}

.video-js .vjs-tech {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-js.vjs-audio-only-mode .vjs-tech {
  display: none;
}

body.vjs-full-window {
  padding: 0;
  margin: 0;
  height: 100%;
}

.vjs-full-window .video-js.vjs-fullscreen {
  position: fixed;
  overflow: hidden;
  z-index: 1000;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.video-js.vjs-fullscreen:not(.vjs-ios-native-fs) {
  width: 100% !important;
  height: 100% !important;
  padding-top: 0 !important;
}

.video-js.vjs-fullscreen.vjs-user-inactive {
  cursor: none;
}

.vjs-hidden {
  display: none !important;
}

.vjs-disabled {
  opacity: 0.5;
  cursor: default;
}

.video-js .vjs-offscreen {
  height: 1px;
  left: -9999px;
  position: absolute;
  top: 0;
  width: 1px;
}

.vjs-lock-showing {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
}

.vjs-no-js {
  padding: 20px;
  color: #fff;
  background-color: #000;
  font-size: 18px;
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
  width: 300px;
  height: 150px;
  margin: 0px auto;
}

.vjs-no-js a, .vjs-no-js a:visited {
  color: #66A8CC;
}

.video-js .vjs-big-play-button {
  font-size: 3em;
  line-height: 1.5em;
  height: 1.63332em;
  width: 3em;
  display: block;
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 0;
  cursor: pointer;
  opacity: 1;
  border: 0.06666em solid #fff;
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
  border-radius: 0.3em;
  transition: all 0.4s;
}

.vjs-big-play-centered .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -0.81666em;
  margin-left: -1.5em;
}

.video-js:hover .vjs-big-play-button, .video-js .vjs-big-play-button:focus {
  border-color: #fff;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
  transition: all 0s;
}

.vjs-controls-disabled .vjs-big-play-button, .vjs-has-started .vjs-big-play-button, .vjs-using-native-controls .vjs-big-play-button, .vjs-error .vjs-big-play-button {
  display: none;
}

.vjs-has-started.vjs-paused.vjs-show-big-play-button-on-pause .vjs-big-play-button {
  display: block;
}

.video-js button {
  background: none;
  border: none;
  color: inherit;
  display: inline-block;
  font-size: inherit;
  line-height: inherit;
  text-transform: none;
  text-decoration: none;
  transition: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.vjs-control .vjs-button {
  width: 100%;
  height: 100%;
}

.video-js .vjs-control.vjs-close-button {
  cursor: pointer;
  height: 3em;
  position: absolute;
  right: 0;
  top: 0.5em;
  z-index: 2;
}

.video-js .vjs-modal-dialog {
  background: rgba(0, 0, 0, 0.8);
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8), rgba(255, 255, 255, 0));
  overflow: auto;
}

.video-js .vjs-modal-dialog > * {
  box-sizing: border-box;
}

.vjs-modal-dialog .vjs-modal-dialog-content {
  font-size: 1.2em;
  line-height: 1.5;
  padding: 20px 24px;
  z-index: 1;
}

.vjs-menu-button {
  cursor: pointer;
}

.vjs-menu-button.vjs-disabled {
  cursor: default;
}

.vjs-workinghover .vjs-menu-button.vjs-disabled:hover .vjs-menu {
  display: none;
}

.vjs-menu .vjs-menu-content {
  display: block;
  padding: 0;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  overflow: auto;
}

.vjs-menu .vjs-menu-content > * {
  box-sizing: border-box;
}

.vjs-scrubbing .vjs-control.vjs-menu-button:hover .vjs-menu {
  display: none;
}

.vjs-menu li {
  list-style: none;
  margin: 0;
  padding: 0.2em 0;
  line-height: 1.4em;
  font-size: 1.2em;
  text-align: center;
  text-transform: lowercase;
}

.vjs-menu li.vjs-menu-item:focus, .vjs-menu li.vjs-menu-item:hover, .js-focus-visible .vjs-menu li.vjs-menu-item:hover {
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
}

.vjs-menu li.vjs-selected, .vjs-menu li.vjs-selected:focus, .vjs-menu li.vjs-selected:hover, .js-focus-visible .vjs-menu li.vjs-selected:hover {
  background-color: #fff;
  color: #2B333F;
}

.video-js .vjs-menu *:not(.vjs-selected):focus:not(:focus-visible), .js-focus-visible .vjs-menu *:not(.vjs-selected):focus:not(.focus-visible) {
  background: none;
}

.vjs-menu li.vjs-menu-title {
  text-align: center;
  text-transform: uppercase;
  font-size: 1em;
  line-height: 2em;
  padding: 0;
  margin: 0 0 0.3em 0;
  font-weight: bold;
  cursor: default;
}

.vjs-menu-button-popup .vjs-menu {
  display: none;
  position: absolute;
  bottom: 0;
  width: 10em;
  left: -3em;
  height: 0em;
  margin-bottom: 1.5em;
  border-top-color: rgba(43, 51, 63, 0.7);
}

.vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
  position: absolute;
  width: 100%;
  bottom: 1.5em;
  max-height: 15em;
}

.vjs-layout-tiny .vjs-menu-button-popup .vjs-menu .vjs-menu-content, .vjs-layout-x-small .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  max-height: 5em;
}

.vjs-layout-small .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  max-height: 10em;
}

.vjs-layout-medium .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  max-height: 14em;
}

.vjs-layout-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content, .vjs-layout-x-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content, .vjs-layout-huge .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
  max-height: 25em;
}

.vjs-workinghover .vjs-menu-button-popup.vjs-hover .vjs-menu, .vjs-menu-button-popup .vjs-menu.vjs-lock-showing {
  display: block;
}

.video-js .vjs-menu-button-inline {
  transition: all 0.4s;
  overflow: hidden;
}

.video-js .vjs-menu-button-inline:before {
  width: 2.222222222em;
}

.video-js .vjs-menu-button-inline:hover, .video-js .vjs-menu-button-inline:focus, .video-js .vjs-menu-button-inline.vjs-slider-active, .video-js.vjs-no-flex .vjs-menu-button-inline {
  width: 12em;
}

.vjs-menu-button-inline .vjs-menu {
  opacity: 0;
  height: 100%;
  width: auto;
  position: absolute;
  left: 4em;
  top: 0;
  padding: 0;
  margin: 0;
  transition: all 0.4s;
}

.vjs-menu-button-inline:hover .vjs-menu, .vjs-menu-button-inline:focus .vjs-menu, .vjs-menu-button-inline.vjs-slider-active .vjs-menu {
  display: block;
  opacity: 1;
}

.vjs-no-flex .vjs-menu-button-inline .vjs-menu {
  display: block;
  opacity: 1;
  position: relative;
  width: auto;
}

.vjs-no-flex .vjs-menu-button-inline:hover .vjs-menu, .vjs-no-flex .vjs-menu-button-inline:focus .vjs-menu, .vjs-no-flex .vjs-menu-button-inline.vjs-slider-active .vjs-menu {
  width: auto;
}

.vjs-menu-button-inline .vjs-menu-content {
  width: auto;
  height: 100%;
  margin: 0;
  overflow: hidden;
}

.video-js .vjs-control-bar {
  display: none;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3em;
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
}

.vjs-has-started .vjs-control-bar, .vjs-audio-only-mode .vjs-control-bar {
  display: flex;
  visibility: visible;
  opacity: 1;
  transition: visibility 0.1s, opacity 0.1s;
}

.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  visibility: visible;
  opacity: 0;
  pointer-events: none;
  transition: visibility 1s, opacity 1s;
}

.vjs-controls-disabled .vjs-control-bar, .vjs-using-native-controls .vjs-control-bar, .vjs-error .vjs-control-bar {
  display: none !important;
}

.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar, .vjs-audio-only-mode.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.vjs-has-started.vjs-no-flex .vjs-control-bar {
  display: table;
}

.video-js .vjs-control {
  position: relative;
  text-align: center;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 4em;
  flex: none;
}

.video-js .vjs-control.vjs-visible-text {
  width: auto;
  padding-left: 1em;
  padding-right: 1em;
}

.vjs-button > .vjs-icon-placeholder:before {
  font-size: 1.8em;
  line-height: 1.67;
}

.vjs-button > .vjs-icon-placeholder {
  display: block;
}

.video-js .vjs-control:focus:before, .video-js .vjs-control:hover:before, .video-js .vjs-control:focus {
  text-shadow: 0em 0em 1em white;
}

.video-js *:not(.vjs-visible-text) > .vjs-control-text {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.vjs-no-flex .vjs-control {
  display: table-cell;
  vertical-align: middle;
}

.video-js .vjs-custom-control-spacer {
  display: none;
}

.video-js .vjs-progress-control {
  cursor: pointer;
  flex: auto;
  display: flex;
  align-items: center;
  min-width: 4em;
  touch-action: none;
}

.video-js .vjs-progress-control.disabled {
  cursor: default;
}

.vjs-live .vjs-progress-control {
  display: none;
}

.vjs-liveui .vjs-progress-control {
  display: flex;
  align-items: center;
}

.vjs-no-flex .vjs-progress-control {
  width: auto;
}

.video-js .vjs-progress-holder {
  flex: auto;
  transition: all 0.2s;
  height: 0.3em;
}

.video-js .vjs-progress-control .vjs-progress-holder {
  margin: 0 10px;
}

.video-js .vjs-progress-control:hover .vjs-progress-holder {
  font-size: 1.6666666667em;
}

.video-js .vjs-progress-control:hover .vjs-progress-holder.disabled {
  font-size: 1em;
}

.video-js .vjs-progress-holder .vjs-play-progress, .video-js .vjs-progress-holder .vjs-load-progress, .video-js .vjs-progress-holder .vjs-load-progress div {
  position: absolute;
  display: block;
  height: 100%;
  margin: 0;
  padding: 0;
  width: 0;
}

.video-js .vjs-play-progress {
  background-color: #fff;
}

.video-js .vjs-play-progress:before {
  font-size: 0.9em;
  position: absolute;
  right: -0.5em;
  top: -0.3333333333em;
  z-index: 1;
}

.video-js .vjs-load-progress {
  background: rgba(115, 133, 159, 0.5);
}

.video-js .vjs-load-progress div {
  background: rgba(115, 133, 159, 0.75);
}

.video-js .vjs-time-tooltip {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 0.3em;
  color: #000;
  float: right;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
  padding: 6px 8px 8px 8px;
  pointer-events: none;
  position: absolute;
  top: -3.4em;
  visibility: hidden;
  z-index: 1;
}

.video-js .vjs-progress-holder:focus .vjs-time-tooltip {
  display: none;
}

.video-js .vjs-progress-control:hover .vjs-time-tooltip, .video-js .vjs-progress-control:hover .vjs-progress-holder:focus .vjs-time-tooltip {
  display: block;
  font-size: 0.6em;
  visibility: visible;
}

.video-js .vjs-progress-control.disabled:hover .vjs-time-tooltip {
  font-size: 1em;
}

.video-js .vjs-progress-control .vjs-mouse-display {
  display: none;
  position: absolute;
  width: 1px;
  height: 100%;
  background-color: #000;
  z-index: 1;
}

.vjs-no-flex .vjs-progress-control .vjs-mouse-display {
  z-index: 0;
}

.video-js .vjs-progress-control:hover .vjs-mouse-display {
  display: block;
}

.video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display {
  visibility: hidden;
  opacity: 0;
  transition: visibility 1s, opacity 1s;
}

.video-js.vjs-user-inactive.vjs-no-flex .vjs-progress-control .vjs-mouse-display {
  display: none;
}

.vjs-mouse-display .vjs-time-tooltip {
  color: #fff;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.8);
}

.video-js .vjs-slider {
  position: relative;
  cursor: pointer;
  padding: 0;
  margin: 0 0.45em 0 0.45em;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #73859f;
  background-color: rgba(115, 133, 159, 0.5);
}

.video-js .vjs-slider.disabled {
  cursor: default;
}

.video-js .vjs-slider:focus {
  text-shadow: 0em 0em 1em white;
  box-shadow: 0 0 1em #fff;
}

.video-js .vjs-mute-control {
  cursor: pointer;
  flex: none;
}

.video-js .vjs-volume-control {
  cursor: pointer;
  margin-right: 1em;
  display: flex;
}

.video-js .vjs-volume-control.vjs-volume-horizontal {
  width: 5em;
}

.video-js .vjs-volume-panel .vjs-volume-control {
  visibility: visible;
  opacity: 0;
  width: 1px;
  height: 1px;
  margin-left: -1px;
}

.video-js .vjs-volume-panel {
  transition: width 1s;
}

.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control, .video-js .vjs-volume-panel:active .vjs-volume-control, .video-js .vjs-volume-panel:focus .vjs-volume-control, .video-js .vjs-volume-panel .vjs-volume-control:active, .video-js .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control, .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active {
  visibility: visible;
  opacity: 1;
  position: relative;
  transition: visibility 0.1s, opacity 0.1s, height 0.1s, width 0.1s, left 0s, top 0s;
}

.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal, .video-js .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control.vjs-volume-horizontal, .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal {
  width: 5em;
  height: 3em;
  margin-right: 0;
}

.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical, .video-js .vjs-volume-panel.vjs-hover .vjs-mute-control ~ .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical {
  left: -3.5em;
  transition: left 0s;
}

.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover, .video-js .vjs-volume-panel.vjs-volume-panel-horizontal:active, .video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active {
  width: 10em;
  transition: width 0.1s;
}

.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-mute-toggle-only {
  width: 4em;
}

.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {
  height: 8em;
  width: 3em;
  left: -3000em;
  transition: visibility 1s, opacity 1s, height 1s 1s, width 1s 1s, left 1s 1s, top 1s 1s;
}

.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {
  transition: visibility 1s, opacity 1s, height 1s 1s, width 1s, left 1s 1s, top 1s 1s;
}

.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal {
  width: 5em;
  height: 3em;
  visibility: visible;
  opacity: 1;
  position: relative;
  transition: none;
}

.video-js.vjs-no-flex .vjs-volume-control.vjs-volume-vertical, .video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {
  position: absolute;
  bottom: 3em;
  left: 0.5em;
}

.video-js .vjs-volume-panel {
  display: flex;
}

.video-js .vjs-volume-bar {
  margin: 1.35em 0.45em;
}

.vjs-volume-bar.vjs-slider-horizontal {
  width: 5em;
  height: 0.3em;
}

.vjs-volume-bar.vjs-slider-vertical {
  width: 0.3em;
  height: 5em;
  margin: 1.35em auto;
}

.video-js .vjs-volume-level {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
}

.video-js .vjs-volume-level:before {
  position: absolute;
  font-size: 0.9em;
  z-index: 1;
}

.vjs-slider-vertical .vjs-volume-level {
  width: 0.3em;
}

.vjs-slider-vertical .vjs-volume-level:before {
  top: -0.5em;
  left: -0.3em;
  z-index: 1;
}

.vjs-slider-horizontal .vjs-volume-level {
  height: 0.3em;
}

.vjs-slider-horizontal .vjs-volume-level:before {
  top: -0.3em;
  right: -0.5em;
}

.video-js .vjs-volume-panel.vjs-volume-panel-vertical {
  width: 4em;
}

.vjs-volume-bar.vjs-slider-vertical .vjs-volume-level {
  height: 100%;
}

.vjs-volume-bar.vjs-slider-horizontal .vjs-volume-level {
  width: 100%;
}

.video-js .vjs-volume-vertical {
  width: 3em;
  height: 8em;
  bottom: 8em;
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
}

.video-js .vjs-volume-horizontal .vjs-menu {
  left: -2em;
}

.video-js .vjs-volume-tooltip {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 0.3em;
  color: #000;
  float: right;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1em;
  padding: 6px 8px 8px 8px;
  pointer-events: none;
  position: absolute;
  top: -3.4em;
  visibility: hidden;
  z-index: 1;
}

.video-js .vjs-volume-control:hover .vjs-volume-tooltip, .video-js .vjs-volume-control:hover .vjs-progress-holder:focus .vjs-volume-tooltip {
  display: block;
  font-size: 1em;
  visibility: visible;
}

.video-js .vjs-volume-vertical:hover .vjs-volume-tooltip, .video-js .vjs-volume-vertical:hover .vjs-progress-holder:focus .vjs-volume-tooltip {
  left: 1em;
  top: -12px;
}

.video-js .vjs-volume-control.disabled:hover .vjs-volume-tooltip {
  font-size: 1em;
}

.video-js .vjs-volume-control .vjs-mouse-display {
  display: none;
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #000;
  z-index: 1;
}

.video-js .vjs-volume-horizontal .vjs-mouse-display {
  width: 1px;
  height: 100%;
}

.vjs-no-flex .vjs-volume-control .vjs-mouse-display {
  z-index: 0;
}

.video-js .vjs-volume-control:hover .vjs-mouse-display {
  display: block;
}

.video-js.vjs-user-inactive .vjs-volume-control .vjs-mouse-display {
  visibility: hidden;
  opacity: 0;
  transition: visibility 1s, opacity 1s;
}

.video-js.vjs-user-inactive.vjs-no-flex .vjs-volume-control .vjs-mouse-display {
  display: none;
}

.vjs-mouse-display .vjs-volume-tooltip {
  color: #fff;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.8);
}

.vjs-poster {
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  background-color: #000000;
  cursor: pointer;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
}

.vjs-has-started .vjs-poster, .vjs-using-native-controls .vjs-poster {
  display: none;
}

.vjs-audio.vjs-has-started .vjs-poster, .vjs-has-started.vjs-audio-poster-mode .vjs-poster {
  display: block;
}

.video-js .vjs-live-control {
  display: flex;
  align-items: flex-start;
  flex: auto;
  font-size: 1em;
  line-height: 3em;
}

.vjs-no-flex .vjs-live-control {
  display: table-cell;
  width: auto;
  text-align: left;
}

.video-js:not(.vjs-live) .vjs-live-control, .video-js.vjs-liveui .vjs-live-control {
  display: none;
}

.video-js .vjs-seek-to-live-control {
  align-items: center;
  cursor: pointer;
  flex: none;
  display: inline-flex;
  height: 100%;
  padding-left: 0.5em;
  padding-right: 0.5em;
  font-size: 1em;
  line-height: 3em;
  width: auto;
  min-width: 4em;
}

.vjs-no-flex .vjs-seek-to-live-control {
  display: table-cell;
  width: auto;
  text-align: left;
}

.video-js.vjs-live:not(.vjs-liveui) .vjs-seek-to-live-control, .video-js:not(.vjs-live) .vjs-seek-to-live-control {
  display: none;
}

.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge {
  cursor: auto;
}

.vjs-seek-to-live-control .vjs-icon-placeholder {
  margin-right: 0.5em;
  color: #888;
}

.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge .vjs-icon-placeholder {
  color: red;
}

.video-js .vjs-time-control {
  flex: none;
  font-size: 1em;
  line-height: 3em;
  min-width: 2em;
  width: auto;
  padding-left: 1em;
  padding-right: 1em;
}

.vjs-live .vjs-time-control {
  display: none;
}

.video-js .vjs-current-time, .vjs-no-flex .vjs-current-time {
  display: none;
}

.video-js .vjs-duration, .vjs-no-flex .vjs-duration {
  display: none;
}

.vjs-time-divider {
  display: none;
  line-height: 3em;
}

.vjs-live .vjs-time-divider {
  display: none;
}

.video-js .vjs-play-control {
  cursor: pointer;
}

.video-js .vjs-play-control .vjs-icon-placeholder {
  flex: none;
}

.vjs-text-track-display {
  position: absolute;
  bottom: 3em;
  left: 0;
  right: 0;
  top: 0;
  pointer-events: none;
}

.video-js.vjs-controls-disabled .vjs-text-track-display, .video-js.vjs-user-inactive.vjs-playing .vjs-text-track-display {
  bottom: 1em;
}

.video-js .vjs-text-track {
  font-size: 1.4em;
  text-align: center;
  margin-bottom: 0.1em;
}

.vjs-subtitles {
  color: #fff;
}

.vjs-captions {
  color: #fc6;
}

.vjs-tt-cue {
  display: block;
}

video::-webkit-media-text-track-display {
  transform: translateY(-3em);
}

.video-js.vjs-controls-disabled video::-webkit-media-text-track-display, .video-js.vjs-user-inactive.vjs-playing video::-webkit-media-text-track-display {
  transform: translateY(-1.5em);
}

.video-js .vjs-picture-in-picture-control {
  cursor: pointer;
  flex: none;
}

.video-js.vjs-audio-only-mode .vjs-picture-in-picture-control {
  display: none;
}

.video-js .vjs-fullscreen-control {
  cursor: pointer;
  flex: none;
}

.video-js.vjs-audio-only-mode .vjs-fullscreen-control {
  display: none;
}

.vjs-playback-rate > .vjs-menu-button, .vjs-playback-rate .vjs-playback-rate-value {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.vjs-playback-rate .vjs-playback-rate-value {
  pointer-events: none;
  font-size: 1.5em;
  line-height: 2;
  text-align: center;
}

.vjs-playback-rate .vjs-menu {
  width: 4em;
  left: 0em;
}

.vjs-error .vjs-error-display .vjs-modal-dialog-content {
  font-size: 1.4em;
  text-align: center;
}

.vjs-error .vjs-error-display:before {
  color: #fff;
  content: "X";
  font-family: Arial, Helvetica, sans-serif;
  font-size: 4em;
  left: 0;
  line-height: 1;
  margin-top: -0.5em;
  position: absolute;
  text-shadow: 0.05em 0.05em 0.1em #000;
  text-align: center;
  top: 50%;
  vertical-align: middle;
  width: 100%;
}

.vjs-loading-spinner {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
  opacity: 0.85;
  text-align: left;
  border: 6px solid rgba(43, 51, 63, 0.7);
  box-sizing: border-box;
  background-clip: padding-box;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  visibility: hidden;
}

.vjs-seeking .vjs-loading-spinner, .vjs-waiting .vjs-loading-spinner {
  display: block;
  -webkit-animation: vjs-spinner-show 0s linear 0.3s forwards;
  animation: vjs-spinner-show 0s linear 0.3s forwards;
}

.vjs-loading-spinner:before, .vjs-loading-spinner:after {
  content: "";
  position: absolute;
  margin: -6px;
  box-sizing: inherit;
  width: inherit;
  height: inherit;
  border-radius: inherit;
  opacity: 1;
  border: inherit;
  border-color: transparent;
  border-top-color: white;
}

.vjs-seeking .vjs-loading-spinner:before, .vjs-seeking .vjs-loading-spinner:after, .vjs-waiting .vjs-loading-spinner:before, .vjs-waiting .vjs-loading-spinner:after {
  -webkit-animation: vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite, vjs-spinner-fade 1.1s linear infinite;
  animation: vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite, vjs-spinner-fade 1.1s linear infinite;
}

.vjs-seeking .vjs-loading-spinner:before, .vjs-waiting .vjs-loading-spinner:before {
  border-top-color: white;
}

.vjs-seeking .vjs-loading-spinner:after, .vjs-waiting .vjs-loading-spinner:after {
  border-top-color: white;
  -webkit-animation-delay: 0.44s;
  animation-delay: 0.44s;
}

@keyframes vjs-spinner-show {
  to {
    visibility: visible;
  }
}
@-webkit-keyframes vjs-spinner-show {
  to {
    visibility: visible;
  }
}
@keyframes vjs-spinner-spin {
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes vjs-spinner-spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes vjs-spinner-fade {
  0% {
    border-top-color: #73859f;
  }
  20% {
    border-top-color: #73859f;
  }
  35% {
    border-top-color: white;
  }
  60% {
    border-top-color: #73859f;
  }
  100% {
    border-top-color: #73859f;
  }
}
@-webkit-keyframes vjs-spinner-fade {
  0% {
    border-top-color: #73859f;
  }
  20% {
    border-top-color: #73859f;
  }
  35% {
    border-top-color: white;
  }
  60% {
    border-top-color: #73859f;
  }
  100% {
    border-top-color: #73859f;
  }
}
.video-js.vjs-audio-only-mode .vjs-captions-button {
  display: none;
}

.vjs-chapters-button .vjs-menu ul {
  width: 24em;
}

.video-js.vjs-audio-only-mode .vjs-descriptions-button {
  display: none;
}

.video-js .vjs-subs-caps-button + .vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder {
  vertical-align: middle;
  display: inline-block;
  margin-bottom: -0.1em;
}

.video-js .vjs-subs-caps-button + .vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before {
  font-family: VideoJS;
  content: "\\f10d";
  font-size: 1.5em;
  line-height: inherit;
}

.video-js.vjs-audio-only-mode .vjs-subs-caps-button {
  display: none;
}

.video-js .vjs-audio-button + .vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder {
  vertical-align: middle;
  display: inline-block;
  margin-bottom: -0.1em;
}

.video-js .vjs-audio-button + .vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before {
  font-family: VideoJS;
  content: " \\f11d";
  font-size: 1.5em;
  line-height: inherit;
}

.video-js.vjs-layout-small .vjs-current-time, .video-js.vjs-layout-small .vjs-time-divider, .video-js.vjs-layout-small .vjs-duration, .video-js.vjs-layout-small .vjs-remaining-time, .video-js.vjs-layout-small .vjs-playback-rate, .video-js.vjs-layout-small .vjs-volume-control, .video-js.vjs-layout-x-small .vjs-current-time, .video-js.vjs-layout-x-small .vjs-time-divider, .video-js.vjs-layout-x-small .vjs-duration, .video-js.vjs-layout-x-small .vjs-remaining-time, .video-js.vjs-layout-x-small .vjs-playback-rate, .video-js.vjs-layout-x-small .vjs-volume-control, .video-js.vjs-layout-tiny .vjs-current-time, .video-js.vjs-layout-tiny .vjs-time-divider, .video-js.vjs-layout-tiny .vjs-duration, .video-js.vjs-layout-tiny .vjs-remaining-time, .video-js.vjs-layout-tiny .vjs-playback-rate, .video-js.vjs-layout-tiny .vjs-volume-control {
  display: none;
}

.video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal:hover, .video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal:active, .video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active, .video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover, .video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal:hover, .video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal:active, .video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active, .video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover, .video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal:hover, .video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal:active, .video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active, .video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover {
  width: auto;
  width: initial;
}

.video-js.vjs-layout-x-small .vjs-progress-control, .video-js.vjs-layout-tiny .vjs-progress-control {
  display: none;
}

.video-js.vjs-layout-x-small .vjs-custom-control-spacer {
  flex: auto;
  display: block;
}

.video-js.vjs-layout-x-small.vjs-no-flex .vjs-custom-control-spacer {
  width: auto;
}

.vjs-modal-dialog.vjs-text-track-settings {
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.75);
  color: #fff;
  height: 70%;
}

.vjs-text-track-settings .vjs-modal-dialog-content {
  display: table;
}

.vjs-text-track-settings .vjs-track-settings-colors, .vjs-text-track-settings .vjs-track-settings-font, .vjs-text-track-settings .vjs-track-settings-controls {
  display: table-cell;
}

.vjs-text-track-settings .vjs-track-settings-controls {
  text-align: right;
  vertical-align: bottom;
}

@supports (display: grid) {
  .vjs-text-track-settings .vjs-modal-dialog-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    padding: 20px 24px 0px 24px;
  }
  .vjs-track-settings-controls .vjs-default-button {
    margin-bottom: 20px;
  }
  .vjs-text-track-settings .vjs-track-settings-controls {
    grid-column: 1/-1;
  }
  .vjs-layout-small .vjs-text-track-settings .vjs-modal-dialog-content, .vjs-layout-x-small .vjs-text-track-settings .vjs-modal-dialog-content, .vjs-layout-tiny .vjs-text-track-settings .vjs-modal-dialog-content {
    grid-template-columns: 1fr;
  }
}
.vjs-track-setting > select {
  margin-right: 1em;
  margin-bottom: 0.5em;
}

.vjs-text-track-settings fieldset {
  margin: 5px;
  padding: 3px;
  border: none;
}

.vjs-text-track-settings fieldset span {
  display: inline-block;
}

.vjs-text-track-settings fieldset span > select {
  max-width: 7.3em;
}

.vjs-text-track-settings legend {
  color: #fff;
  margin: 0 0 5px 0;
}

.vjs-text-track-settings .vjs-label {
  position: absolute;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  display: block;
  margin: 0 0 5px 0;
  padding: 0;
  border: 0;
  height: 1px;
  width: 1px;
  overflow: hidden;
}

.vjs-track-settings-controls button:focus, .vjs-track-settings-controls button:active {
  outline-style: solid;
  outline-width: medium;
  background-image: linear-gradient(0deg, #fff 88%, #73859f 100%);
}

.vjs-track-settings-controls button:hover {
  color: rgba(43, 51, 63, 0.75);
}

.vjs-track-settings-controls button {
  background-color: #fff;
  background-image: linear-gradient(-180deg, #fff 88%, #73859f 100%);
  color: #2B333F;
  cursor: pointer;
  border-radius: 2px;
}

.vjs-track-settings-controls .vjs-default-button {
  margin-right: 1em;
}

@media print {
  .video-js > *:not(.vjs-tech):not(.vjs-poster) {
    visibility: hidden;
  }
}
.vjs-resize-manager {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  z-index: -1000;
}

.js-focus-visible .video-js *:focus:not(.focus-visible) {
  outline: none;
}

.video-js *:focus:not(:focus-visible) {
  outline: none;
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rvp-video-root {
  width: 100%;
  height: 100%;
}

.rvp-video.video-js {
  background-color: transparent;
  font-family: "Helvetica Neue";
  font-size: 16px;
}

.rvp-video.video-js.vjs-playing.replay .vjs-tech, .rvp-video.video-js.vjs-playing.sound .vjs-tech {
  pointer-events: none;
}

.rvp-video.video-js .vjs-text-track-display {
  z-index: 2;
  bottom: 3.5em;
}

.rvp-video.video-js .vjs-text-track-display .vjs-text-track-cue > div {
  border-radius: 8px;
  display: inline-block !important;
  padding: 7px 10px;
  backdrop-filter: blur(27.1828px);
}

.rvp-video.video-js .vjs-loading-spinner {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  visibility: visible;
  -webkit-animation: rotating 1s linear infinite;
  -moz-animation: rotating 1s linear infinite;
  -ms-animation: rotating 1s linear infinite;
  -o-animation: rotating 1s linear infinite;
  animation: rotating 1s linear infinite;
  opacity: unset;
  border: none;
  border-radius: unset;
}

.rvp-video.video-js .vjs-loading-spinner::before, .rvp-video.video-js .vjs-loading-spinner::after {
  display: none;
}

.rvp-video.video-js .vjs-control-bar {
  font-size: 16px;
  background-color: unset;
  height: 3em;
  bottom: 0;
  padding: 0 1em;
}

.rvp-video.video-js .vjs-control-bar:before {
  content: "";
  display: block;
  width: 100%;
  height: 15em;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00004) 0.56%, rgba(0, 0, 0, 0.4) 99.81%);
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.rvp-video.video-js.vjs-fullscreen .vjs-control.vjs-fullscreen-control {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center;
}

.rvp-video.video-js:not(.vjs-fullscreen) .vjs-control.vjs-fullscreen-control {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center;
}

.rvp-video.video-js .nrvp-captions-button {
  display: flex;
}

.rvp-video.video-js .nrvp-captions-button .nrvp-control.nrvp-captions {
  padding: 0;
}

.rvp-video.video-js .nrvp-captions-button .nrvp-control.nrvp-captions .vjs-icon-placeholder {
  display: none;
}

.rvp-video.video-js .nrvp-captions-button.captions-on .nrvp-control.nrvp-captions {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center;
}

.rvp-video.video-js .nrvp-captions-button.captions-off .nrvp-control.nrvp-captions {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center;
}

.rvp-video.video-js .nrvp-captions-button .vjs-menu .vjs-texttrack-settings {
  display: none;
}

.rvp-video.video-js .vjs-control {
  height: 1.5em;
  width: 1.5em;
  margin: 0 0.5em;
  z-index: 2;
}

.rvp-video.video-js .vjs-control.vjs-button.nrvp-hidden {
  visibility: hidden;
}

.rvp-video.video-js .vjs-control.vjs-button > .vjs-icon-placeholder {
  display: none;
}

.rvp-video.video-js .vjs-control.vjs-button.vjs-play-control {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center;
}

.rvp-video.video-js .vjs-control.vjs-button.vjs-play-control.vjs-paused {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center;
}

.rvp-video.video-js .vjs-control.vjs-button.nrvp-control.vjs-ended {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center;
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu {
  left: -14.7em;
  width: 16em;
  height: 2em;
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content {
  color: #b2b2b2;
  font-family: "Helvetica Neue";
  font-size: 16px;
  padding: 8px 2px;
  border-radius: 8px;
  bottom: 1.5em;
  backdrop-filter: blur(27.1828px);
  background-color: rgba(17, 17, 17, 0.8);
  text-shadow: 0px 0px 24px rgba(0, 0, 0, 0.5);
  scrollbar-width: thin;
  scrollbar-color: white rgba(17, 17, 17, 0.8);
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content::-webkit-scrollbar {
  width: 12px;
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content::-webkit-scrollbar-track {
  background: rgba(17, 17, 17, 0.8);
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content::-webkit-scrollbar-thumb {
  background-color: white;
  border-radius: 20px;
  border: 3px solid white;
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content .vjs-menu-item {
  text-align: start;
  text-transform: capitalize;
  font-size: 16px;
  padding: 0.5em 0 0.5em 0.5em;
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content .vjs-menu-item .vjs-menu-item-text {
  display: inline-block;
  width: calc(100% - 1.2em);
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content .vjs-menu-item:hover, .rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content .vjs-menu-item.vjs-selected:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content .vjs-menu-item::before {
  content: "";
  margin-right: 0.75em;
  display: inline-block;
  position: relative;
  width: 6px;
  height: 14px;
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content .vjs-menu-item.vjs-selected {
  background-color: unset;
  color: white;
  font-weight: 500;
}

.rvp-video.video-js .vjs-control.vjs-button .vjs-menu .vjs-menu-content .vjs-menu-item.vjs-selected::before {
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.rvp-video.video-js .vjs-control .vjs-slider:focus, .rvp-video.video-js .vjs-control.vjs-button:focus, .rvp-video.video-js .vjs-menu-item:focus, .rvp-video.video-js .vjs-menu-button:focus {
  outline: solid 2px rgba(27, 127, 204, 0.8);
}

.rvp-video.video-js .vjs-time-control {
  height: 1.5em;
  line-height: 1.45em;
  margin-right: 0.5em;
  padding: 0;
  width: fit-content;
}

.rvp-video.video-js .vjs-progress-control {
  margin: 0 0.5em 0 0.75em;
  height: 1.5em;
}

.rvp-video.video-js .vjs-progress-control:hover .vjs-progress-holder {
  font-size: 16px;
}

.rvp-video.video-js .vjs-progress-control .vjs-time-tooltip {
  color: white;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 10px;
  padding: 0.5em;
  top: -3.6em;
  z-index: 3;
}

.rvp-video.video-js .vjs-progress-control.vjs-hidden {
  visibility: hidden;
  display: flex !important;
}

.rvp-video.video-js .vjs-progress-control .vjs-slider, .rvp-video.video-js .vjs-progress-control .vjs-load-progress, .rvp-video.video-js .vjs-progress-control .vjs-play-progress {
  border-radius: 2px;
}

.rvp-video.video-js .vjs-progress-control .vjs-slider {
  background-color: rgba(255, 255, 255, 0.2);
  height: 0.25em;
  margin: 0;
}

.rvp-video.video-js .vjs-progress-control .vjs-load-progress {
  background: none;
}

.rvp-video.video-js .vjs-progress-control .vjs-load-progress > div {
  background: rgba(255, 255, 255, 0.3);
}

.rvp-video.video-js .vjs-progress-control .vjs-play-progress::before {
  font-size: 0.75em;
}

.rvp-video.video-js .vjs-remaining-time :nth-child(2) {
  display: none;
}

.rvp-video.video-js .vjs-progress-control .vjs-mouse-display, .rvp-video.video-js .vjs-mouse-display .vjs-time-tooltip, .rvp-video.video-js .vjs-time-tooltip {
  background-color: white;
  background-color: rgba(17, 17, 17, 0.8);
}

.rvp-video.video-js .vjs-control.vjs-volume-panel .vjs-control.nrvp-control.nrvp-mute-control {
  margin: 0;
}

.rvp-video.video-js .vjs-control.vjs-volume-panel .vjs-control.nrvp-control.nrvp-mute-control.vjs-vol-0 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center;
}

.rvp-video.video-js .vjs-control.vjs-volume-panel .vjs-control.nrvp-control.nrvp-mute-control.vjs-vol-1 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center;
}

.rvp-video.video-js .vjs-control.vjs-volume-panel .vjs-control.nrvp-control.nrvp-mute-control.vjs-vol-2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat center;
}

.rvp-video.video-js .vjs-control.vjs-volume-panel .vjs-control.vjs-volume-control.vjs-volume-vertical {
  background: transparent;
  left: -1.5em;
  width: 1.5em;
  margin: 0;
  bottom: 6em;
  height: 6em;
}

.rvp-video.video-js .vjs-control.vjs-volume-panel .vjs-control.vjs-volume-control.vjs-volume-vertical .vjs-volume-bar {
  background-color: rgba(255, 255, 255, 0.25);
}

.rvp-video.video-js .vjs-control.vjs-volume-panel .vjs-control.vjs-volume-control.vjs-volume-vertical .vjs-volume-bar.vjs-slider-vertical {
  margin: 1em auto;
  height: 4em;
  border-radius: 2px;
  width: 0.25em;
}

.rvp-video.video-js .vjs-control.vjs-volume-panel .vjs-control.vjs-volume-control.vjs-volume-vertical .vjs-volume-bar.vjs-slider-vertical .vjs-volume-level {
  border-radius: 2px;
  width: 0.25em;
}

.rvp-video.video-js .vjs-control.vjs-volume-panel .vjs-control.vjs-volume-control.vjs-volume-vertical .vjs-volume-bar.vjs-slider-vertical .vjs-volume-level::before {
  font-size: 0.75em;
  left: -0.35em;
}

.rvp-video.video-js .vjs-audio-button .vjs-button > .vjs-icon-placeholder:before {
  font-size: 1.5em;
  line-height: 1.1em;
}

.rvp-video.video-js .vjs-live-control {
  font-size: 1em;
  line-height: 1.6em;
}

.rvp-video.video-js:hover .vjs-big-play-button {
  background-color: rgba(17, 17, 17, 0.6);
}

.rvp-video.video-js .vjs-big-play-button {
  background-color: rgba(17, 17, 17, 0.8);
  border: unset;
  border-radius: 50%;
  height: 1em;
  width: 1em;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.rvp-video.video-js .vjs-big-play-button .vjs-icon-placeholder {
  font-size: 0.8em;
  line-height: 1.2em;
}

.rvp-video.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  color: white;
}

.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar.always-show {
  visibility: visible;
  opacity: 1;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
